
import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/installations'
import 'firebase/performance'
import 'firebase/auth'
import CustomButton from '@/components/Button.vue'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faInstagram } from '@fortawesome/free-brands-svg-icons'
import {
  faHeart,
  faComment,
  faCircle
} from '@fortawesome/free-regular-svg-icons'
import {
  faQuestionCircle,
  faTimes,
  faTimesCircle,
  faBars,
  faCheckCircle,
  faAngleDoubleDown,
  faCog,
  faExclamationTriangle,
  faThumbsUp,
  faThumbsDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faCaretDown,
  faUserCircle,
  faUserCog,
  faKey,
  faDumbbell,
  faDollarSign,
  faChartLine,
  faIdCard,
  faSignOutAlt,
  faCheck,
  faInfoCircle,
  faSpinner,
  faUserPlus,
  faUserEdit,
  faCreditCard,
  faPencilAlt,
  faArrowLeft
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'

const firebaseConfig = {
  apiKey: 'AIzaSyASznDVR8y1ALQEQIRhyY_5tsmdOZQ4byQ',
  authDomain: 'nordicperformancecenter-57600.firebaseapp.com',
  databaseURL: 'https://nordicperformancecenter-57600.firebaseio.com',
  projectId: 'nordicperformancecenter-57600',
  storageBucket: 'nordicperformancecenter-57600.appspot.com',
  messagingSenderId: '521680512918',
  appId: '1:521680512918:web:cecd61e31d2490d7d29fb7'
}

firebase.initializeApp(firebaseConfig)
firebase.performance()

global.db = firebase.firestore()

global.firebase = firebase
const bugsnagClient = bugsnag('08d6b8a2dda60d767a02aafab45f1869')

library.add(faInstagram)
library.add(faHeart)
library.add(faComment)
library.add(faQuestionCircle)
library.add(faTimes)
library.add(faTimesCircle)
library.add(faBars)
library.add(faCheckCircle)
library.add(faCircle)
library.add(faAngleDoubleDown)
library.add(faCog)
library.add(faExclamationTriangle)
library.add(faThumbsUp)
library.add(faThumbsDown)
library.add(faCaretLeft)
library.add(faCaretRight)
library.add(faCaretUp)
library.add(faCaretDown)
library.add(faUserCog)
library.add(faUserCircle)
library.add(faKey)
library.add(faDumbbell)
library.add(faDollarSign)
library.add(faChartLine)
library.add(faIdCard)
library.add(faSignOutAlt)
library.add(faCheck)
library.add(faInfoCircle)
library.add(faSpinner)
library.add(faUserPlus)
library.add(faUserEdit)
library.add(faCreditCard)
library.add(faPencilAlt)
library.add(faArrowLeft)

export default Vue => {
  bugsnagClient.use(bugsnagVue, Vue)

  Vue.component('CustomButton', CustomButton)
  Vue.component('font-awesome-icon', FontAwesomeIcon)

  return Vue
}

global.bugsnagClient = bugsnagClient
